import React, {useState, useEffect, useRef} from 'react';

import ExtendedButton from '@src/stories/elements/ExtendedButton/ExtendedButton';
import { fetchCart } from 'frontend/js/useShopifyCart';
import CartTitle from './components/CartTitle';
import CartItems from './components/CartItems';
import shippingitem from "frontend/js/alpine/components/cart/shippingitem";
import { updateItems } from 'frontend/js/useShopifyCart';
import { useCart } from 'frontend/js/useShopifyCart';


export default function ExtendedMinicart ({ style = 'drawer', settings, shipping_id,  gift_wrap_types, card_types }) {
  const { cart, hampers } = useCart(true);
  const [updatingCart, setUpdatingCart] = useState(false);
  const excludedIds = [
    // ...card_types.map(item => item.id),
    // ...gift_wrap_types.map(item => item.id),
    Number(shipping_id)
  ];
  const submitCheckoutBtn = useRef(null); 

  
  const filteredCartItems = cart && cart.items.filter(
    (cartItem) => !excludedIds.includes(cartItem.variant_id)
  );

  const shippingItems = cart && cart.items.filter((item) => item.id === Number(shipping_id));
  const totalShippingPrice = shippingItems && shippingItems.reduce((acc, item) => acc + item.price, 0);

  // Update and delete shipping cost items on initial cart journey load if minicart only has gift cards
  const removeShippingItems = shippingItems.reduce((acc, item) => {
    acc[item.key] = 0;
    return acc;
  }, {});

  const isGiftCardOnlyCart =  filteredCartItems && filteredCartItems.every(
    item => item.product_type === "Gift Cards"
  );

  async function handleValidation () {
    if (isGiftCardOnlyCart) {
      setUpdatingCart(true);
      try {
        // Direct fetch call to update cart
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates: removeShippingItems }),
        });
        
        if (response.ok) {
          setTimeout(() => {
            submitCheckoutBtn.current.submit();
       
          }, 500);
        } else {
          console.error('Failed to update cart');
        }
      } catch (error) {
        console.error('Error updating cart:', error);
      } finally {
        setUpdatingCart(false);
      }
    }
    else {
      window.location.href = '/cart';
    }
  } 

  return (
    <>
      <div
        className='extended-minicart__overlay'
        x-cloak="true"
        x-show="$store.global.isMinicartVisible"
      />

      <div className={`extended-minicart__wrapper ${style}`}
        x-cloak="true"
        x-transition:enter="transition ease-out duration-300"
        x-transition:enter-start="off-screen-right"
        x-transition:enter-end="right-50"
        x-transition:leave="transition ease-in duration-300"
        x-transition:leave-start="right-50"
        x-transition:leave-end="off-screen-right"
        x-show="$store.global.isMinicartVisible"
      >
        <div className={'extended-minicart overflow-auto'}>
          <CartTitle item_count={filteredCartItems && filteredCartItems.length} />

          <CartItems
            cartItems={filteredCartItems}
            hampers={hampers}
            show_total_price={settings.show_total_price}
          />

          {cart.items.length === 0
            ? <div className={'flex flex-col gap-y-[16px] text-center h-full justify-center p-[16px]'}>
                <div className={'b2'}>
                  {settings.empty_text_one}

                  <br/>

                  {settings.empty_text_two}
                </div>

                <a
                  x-on:click="$store.global.toggleMinicart()"
                  className={'minicart-empty__button button button-primary'}
                >
                  {settings.empty_button}
                </a>
              </div>

            : <div className='extended-minicart__footer'>
                <div className="extended-minicart__total">
                  <h5 className='h5'>
                    Total
                  </h5>

                  <h5 className='h5'>
                    {`$${((cart.total_price - totalShippingPrice) / 100).toFixed(2)}`}
                  </h5>
                </div>

                <div className='extended-minicart__checkout-button'>
                  <ExtendedButton
                    style="primary"
                    label={ updatingCart ? "Updating Cart..." : "Checkout" }
                    disabled={updatingCart}
                    onClick={() => handleValidation()}
                  />

                <form id="checkout" action="/checkout" method="post" ref={submitCheckoutBtn}></form>
                </div>
              </div>
          }
        </div>
      </div>
    </>
  );
}
